import { Injectable } from '@angular/core';
import { PrincipalSloApi } from 'src/app/api/principal-slo/principal-slo.api';

@Injectable()
export class PrincipalSloService {
    constructor(private principalSloApi: PrincipalSloApi) { }

    getObservationDetails = (observationId: string) =>
        this.principalSloApi.getObservationDetails(observationId);
}
